// components/Analytics/DevicePieChart.js
import { Chart } from 'primereact/chart';

function PieChart({ data, config }) {
  const options = { maintainAspectRatio: false };

  return (
    <Chart type="pie" data={data} options={options} className="h-[400px]" />
  );
}

export default PieChart;